<div class="promo-banner">
    <xm-media-image [imageOptions]="infoIconOptions" size="width" center="vert" class="icon"></xm-media-image>
    <div class="promo-banner-list">
        <p>{{ banner.header }}</p>
        <div class="promo-content">
            <ul class="description">
                <li *ngFor="let promo of promoList">
                    {{ promo.text }}
                </li>
            </ul>
        </div>
    </div>
</div>
